<div>
  <div class="flex items-center justify-center h-[70px]">
    <h4 class="xl:text-xl lg:text-lg text-primary text-lg font-medium font-sans font-medium">
    {{dialogData?.headerMsg ? dialogData.headerMsg : 'Assign Work Order'}} </h4>
  </div>
  <mat-dialog-content class="!pt-0">
    <!-- TODO: Add dispatch WO technician details -->
    <!-- <div *ngIf="dialogData.length === 1 && (dialogData[0].technician || dialogData[0].companyName)" class="h-[45px] font-sans font-medium">
    <h2 *ngIf="dialogData[0].technician" class="text-primary float-left">
      <span class="text-black">User Name <br> </span> {{ dialogData[0].technician }}
    </h2>
    <h2 *ngIf="dialogData[0].companyName" class="text-primary float-right">
      <span class="text-black">Company Name <br> </span> {{ dialogData[0].companyName }}
    </h2>
  </div> -->
  <form [formGroup]="reassignWoForm" class="!mt-1">
    <!-- Assign technician dropdown -->
    <div class="mb-2">
      @if(skillDisplayText()) {
        <p class="text-[12px] text-start text-[#944e0e] mb-1">
          <span class="font-sans font-semibold">Please note:</span>
          You can see only people with {{ skillList.length > 1 ? 'these skills' : ''}}
          <span class="font-sans font-semibold">"{{ skillDisplayText() }}"</span>
          {{ skillList.length === 1 ? 'Skill' : ''}}
        </p>
      }
      <mat-form-field appearance="outline" class="w-full hide-hint">
        <mat-label>Select User</mat-label>
        <mat-select formControlName="techId" (selectionChange)="assignToChange()">
          <mat-option>
            <ngx-mat-select-search [formControl]="technicianSearchControl" placeholderLabel="Search"
            [noEntriesFoundLabel]="'No data found'" class="small-icon"></ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="0">None</mat-option>
          @for (user of assignedUserList; track user) {
            <mat-option [value]="user.id">
              {{ user.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (displayUserNotFoundMsg && assignedUserList?.length === 0) {
        <p class="text-[12px] text-start text-[red]">No user found with these skills. Try to select WO which has same WO type.</p>
      }
    </div>

    <!-- Partner company dropdown -->
    <div>
      <mat-form-field appearance="outline" class="w-full !mt-4">
        <mat-label>Select Company</mat-label>
        <mat-select formControlName="partnerCompanyId" (selectionChange)="onPartnerCmpChange($event)">
          <mat-option>
            <ngx-mat-select-search [formControl]="partnerCmpSearchControl" placeholderLabel="Search"
            [noEntriesFoundLabel]="'No data found'" class="small-icon"></ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="0">None</mat-option>
          @for (partnerCmp of partnerCompanyList; track partnerCmp) {
            <mat-option [value]="partnerCmp.id">
              {{ partnerCmp.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mb-4">
      <div>
        <mat-slide-toggle class="cmn-slide-toggle font-sans font-medium" formControlName="assignLinkedWo"
          labelPosition="before" (change)="toggleLinkWO($event)">
          <div class="flex items-center gap-1">Assign with child linked work order<mat-icon
            class="text-lg text-primary mb-1"
          matTooltip="Turn the toggle on to assign all child Linked WO as well" svgIcon="c:info-circle"></mat-icon></div>
        </mat-slide-toggle>
      </div>
    </div>

    <!-- Submit Button -->
    <mat-dialog-actions class="!p-0 flex !justify-center !mb-3">
      <button mat-flat-button mat-dialog-close color="accent"
      class="text-primary secondary-button">Cancel</button>
      <button mat-flat-button class="text-primary primary-button"
      (click)="onSubmit()">{{ isNotAssign ? 'Dispatch' : 'Reassign'}}</button>
    </mat-dialog-actions>
  </form>
</mat-dialog-content>
<!-- </div> -->
</div>